<template>
<div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
        <v-card color="grey lighten-5" flat>
            <v-layout row wrap>
                <v-flex xs12 sm12>
                    <v-toolbar size="120px" dark color="info">
                        <v-toolbar-title>{{ $t('Statement-of-Account') }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="this.$t('Search')" append-icon="search">
                        </v-text-field>
<v-btn color="pink lighten-1" dark @click="openMailDialog" small>
  <v-icon left>email</v-icon> Mail Gönder
</v-btn>

                        <v-menu offset-y>
                            <v-btn slot="activator" dark icon>
                                <v-icon>more_vert</v-icon>
                            </v-btn>
                            <v-list>

                                <v-list-tile @click="getListHtml()">
                                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                                </v-list-tile>

                                <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">
                                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                                </v-list-tile>

                            </v-list>
                        </v-menu>

                    </v-toolbar>
                </v-flex>
<!-- MAIL GÖNDER DIALOG -->
<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>
  <v-card>
    <v-toolbar dense flat color="info" dark>
      <v-toolbar-title>Mail Gönder</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>
    </v-toolbar>

    <v-card-text>
      <v-form ref="mailForm" v-model="mailValid" lazy-validation>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-model="mailPayload.To"
              label="Kime (e-posta)"
              :rules="[rules.required, rules.email]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgencyName"
              label="Agency Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.DocType"
              label="Doc Type (sabit)"
              :rules="[rules.required]"
              :disabled="true"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgentFullName"
              label="Agent Full Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              v-model="mailPayload.CustomBody"
              label="Mesaj"
              :rules="[rules.required]"
              auto-grow
              rows="3"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>
      <v-btn
        color="info"
        :loading="mailLoading"
        :disabled="!mailValid || mailLoading"
        @click="sendMail"
      >
        <v-icon left>send</v-icon>Gönder
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


                <v-container v-show="EkstreHesap.RaporDvzTip == 0" fluid="">
                    <v-layout row wrap>

                        <v-flex xs12 sm6 md4 style="padding-right:2px;padding-bottom:4px;">
                            <v-card color="#1E88E5" class="white--text">
                                <v-layout>
                                    <v-flex xs2 sm2 md2>
                                        <v-layout align-center="" justify-center="" fill-height="">
                                            <v-icon color="white" large="">cached</v-icon>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm10 md10>

                                        <v-card-title primary-title="">
                                            <v-flex xs12 sm12 md12>
                                                <v-layout>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-list-tile-title>
                                                            <span class="subheading font-weight-">
                                                                {{ $t('Transfer-Payable') }}
                                                            </span>
                                                        </v-list-tile-title>
                                                    </v-flex>
                                                    <v-flex xs12 sm9 md8>
                                                        <v-list-tile-title>
                                                            <span class="subheading font-weight-">
                                                                : {{ devirborc | moneyformat }}{{getparabirimi()}}
                                                            </span>
                                                        </v-list-tile-title>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm12 md12>
                                                <v-layout>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-list-tile-title>
                                                            <span class="subheading font-weight-">
                                                                {{ $t('Transfer-Receivable') }}
                                                            </span>
                                                        </v-list-tile-title>
                                                    </v-flex>
                                                    <v-flex xs12 sm9 md8>
                                                        <v-list-tile-title>
                                                            <span class="subheading font-weight-">
                                                                : {{ deviralacak | moneyformat }}{{getparabirimi()}}
                                                            </span>
                                                        </v-list-tile-title>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                        </v-card-title>

                                    </v-flex>
                                </v-layout>
                                <v-divider light></v-divider>
                                <v-card-actions class="pa-3">
                                    <span class="subheading font-weight-bold"> {{$t('Transfer-Balance')}} : {{ devirbakiye }}</span>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <v-flex xs12 sm6 md4 style="padding-right:2px; padding-bottom:4px;">
                            <v-card color="#1E88E5" class="white--text">
                                <v-layout>
                                    <v-flex xs2 sm2 md2>
                                        <v-layout align-center="" justify-center="" fill-height="">
                                            <v-icon color="white" large="">layers</v-icon>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm10 md10>

                                        <v-card-title primary-title="">
                                            <v-flex xs12 sm12 md12>
                                                <v-layout>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-list-tile-title>
                                                            <span class="subheading font-weight-">
                                                                {{ $t('Payable-for-Period') }}
                                                            </span>
                                                        </v-list-tile-title>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-list-tile-title>
                                                            <span class="subheading font-weight-">
                                                                : {{ donemborc | moneyformat }}{{getparabirimi()}}
                                                            </span>
                                                        </v-list-tile-title>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm12 md12>
                                                <v-layout>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-list-tile-title>
                                                            <span class="subheading font-weight-">
                                                                {{ $t('Receivable-for-Period') }}
                                                            </span>
                                                        </v-list-tile-title>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-list-tile-title>
                                                            <span class="subheading font-weight-">
                                                                : {{ donemalacak | moneyformat }}{{getparabirimi()}}
                                                            </span>
                                                        </v-list-tile-title>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                        </v-card-title>

                                    </v-flex>
                                </v-layout>
                                <v-divider light></v-divider>
                                <v-card-actions class="pa-3"> <span class="subheading font-weight-bold">
                                        {{$t('Balance-for-Period')}} : {{ donembakiye }} </span>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <v-flex xs12 sm12 md4 style="padding-right:2px; padding-bottom:6px;">
                            <v-card color="#1E88E5" class="white--text">
                                <v-layout>
                                    <v-flex xs2 sm2 md2>
                                        <v-layout align-center="" justify-center="" fill-height="">
                                            <v-icon color="white" large="">queue</v-icon>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm10 md10>

                                        <v-card-title primary-title="">
                                            <v-flex xs12 sm12 md12>
                                                <v-layout>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-list-tile-title>
                                                            <span class="subheading font-weight-">
                                                                {{ $t('Total-Debit') }}
                                                            </span>
                                                        </v-list-tile-title>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-list-tile-title>
                                                            <span class="subheading font-weight-">
                                                                : {{ toplamborc | moneyformat }}{{getparabirimi()}}
                                                            </span>
                                                        </v-list-tile-title>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm12 md12>
                                                <v-layout>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-list-tile-title>
                                                            <span class="subheading font-weight-">
                                                                {{ $t('Total-Credit') }}
                                                            </span>
                                                        </v-list-tile-title>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-list-tile-title>
                                                            <span class="subheading font-weight-">
                                                                : {{ toplamalacak | moneyformat }}{{getparabirimi()}}
                                                            </span>
                                                        </v-list-tile-title>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                        </v-card-title>

                                    </v-flex>
                                </v-layout>
                                <v-divider light></v-divider>
                                <v-card-actions class="pa-3"> <span class="subheading font-weight-bold">
                                        {{ $t('Total-Balance') }} : {{ toplambakiye }} </span>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                    </v-layout>
                </v-container>

                <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="800px">
                    <v-card color="grey lighten-5">
                        <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-layout row="" wrap="">
                                <v-flex pa-1 xs12 sm12 md6>
                                    <v-card flat="" class="white--text">
                                        <v-card color="grey lighten-5" flat="">
                                            <v-card-actions>
                                                <v-layout justify-space-between column>

                                                    <referansmerkezicomp :coper="false" :tabdeger="'37'" v-model="ReferansPrm.Kod" >
                              </referansmerkezicomp>
                                                    <!-- <v-autocomplete hide-details :items="Referans" clearable v-model="EkstreHesap.IstenilenReferanslar" :label="$t('References-Requested')" multiple item-text="ReferansAd" item-value="Kod">
                                                        <template slot="selection" slot-scope="{ item, index }">
                                                            <v-chip v-if="index === 0">
                                                                <h4> <span>{{ item.Kod }}</span> </h4>
                                                            </v-chip>
                                                            <span v-if="index === 1" class="grey--text caption">(+{{
                                  EkstreHesap.IstenilenReferanslar.length - 1 }} {{ $t('other-record') }})</span>
                                                        </template>
                                                    </v-autocomplete> -->

                                                    <v-autocomplete hide-details :items="masrafmerkezi" clearable v-model="EkstreHesap.Masraflar" :label="$t('Expense-Center-v2')" multiple item-text="Title" item-value="Code">
                                                        <template slot="selection" slot-scope="{ item, index }">
                                                            <v-chip v-if="index === 0">
                                                                <h4> <span>{{ item.Code }}</span> </h4>
                                                            </v-chip>
                                                            <span v-if="index === 1" class="grey--text caption">(+{{
                                  EkstreHesap.Masraflar.length - 1 }} {{ $t('other-record') }})</span>
                                                        </template>
                                                    </v-autocomplete>

                                                    <v-autocomplete hide-details :items="hesapgurubu" clearable v-model="EkstreHesap.Gruplar" :label="$t('Groups-Requested')" multiple item-text="Title" item-value="Code">
                                                        <template slot="selection" slot-scope="{ item, index }">
                                                            <v-chip v-if="index === 0">
                                                                <h4> <span>{{ item.Kod }}</span> </h4>
                                                            </v-chip>
                                                            <span v-if="index === 1" class="grey--text caption">(+{{
                                  EkstreHesap.Gruplar.length - 1 }} {{ $t('other-record') }})</span>
                                                        </template>
                                                    </v-autocomplete>

                                                </v-layout>
                                            </v-card-actions>
                                        </v-card>
                                    </v-card>
                                </v-flex>

                                <v-flex pa-1 xs12 sm12 md6>
                                    <v-card flat="" class="white--text">
                                        <v-card color="grey lighten-5" flat="">
                                            <v-card-actions>
                                                <v-layout justify-space-between column>
                                                    <referansmerkezicomp :coper="false" :tabdeger="'37'" v-model="NoReferansPrm.Kod" >
                              </referansmerkezicomp>
                                                    <!-- <v-autocomplete hide-details clearable :items="Referans" v-model="EkstreHesap.IstenmeyenReferanslar" :label="$t('Unwanted-References')" multiple item-text="ReferansAd" item-value="Kod">
                                                        <template slot="selection" slot-scope="{ item, index }">
                                                            <v-chip v-if="index === 0">
                                                                <h4> <span>{{ item.Kod }}</span> </h4>
                                                            </v-chip>
                                                            <span v-if="index === 1" class="grey--text caption">(+{{
                                  EkstreHesap.IstenmeyenReferanslar.length - 1 }} {{ $t('other-record') }})</span>
                                                        </template>
                                                    </v-autocomplete> -->

                                                    <v-autocomplete hide-details clearable :items="evraktipi" v-model="EkstreHesap.Evraklar" :label="$t('Document-Type')" multiple item-text="Title" item-value="Evrakkod">
                                                        <template slot="selection" slot-scope="{ item, index }">
                                                            <v-chip v-if="index === 0">
                                                                <h4> <span>{{ item.Evrakkod }}</span> </h4>
                                                            </v-chip>
                                                            <span v-if="index === 1" class="grey--text caption">(+{{
                                  EkstreHesap.Evraklar.length - 1 }} {{ $t('other-record') }})</span>
                                                        </template>
                                                    </v-autocomplete>

                          
                                                </v-layout>
                                            </v-card-actions>
                                        </v-card>
                                    </v-card>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-card flat="" color="info">
                                        <v-card-title>
                                            <span class="subheading white--text font-weight-medium "> {{ $t('Options-v2') }}</span>
                                        </v-card-title>
                                    </v-card>
                                </v-flex>

                                <v-flex xs12 sm6 md3>
                                    <v-radio-group v-model="EkstreHesap.RaporTip" :label="$t('Report-Type')" column>
                                        <v-radio :label="$t('Details')" :value="false"></v-radio>
                                        <v-radio :label="$t('Summary')" :value="true"> </v-radio>
                                    </v-radio-group>
                                </v-flex>

                                <v-flex xs12 sm6 md3>
                                    <v-radio-group  :disabled="isDisabled" v-model="EkstreHesap.RaporDvzTip" :label="$t('Report-Currency-Type')" column>
                                        <v-radio :label="this.getparabirimi()" :value="0"> </v-radio>
                                        <v-radio :label="$t('Currency')" :value="1"> </v-radio>
                                        <v-radio :label= "this.getparabirimi() + ' ' + '+' + ' ' +  $t('Currency')" :value="2"> </v-radio>
                                    </v-radio-group>
                                </v-flex>

                                <v-flex xs12 sm6 md3>
                                    <v-radio-group :disabled="EkstreHesap.RaporTip==1" v-model="EkstreHesap.Tarihler" :label="$t('Date-of-Detailed-Statement')" column>
                                        <v-radio :label="$t('Date')" :value="0"> </v-radio>
                                        <v-radio :label="$t('Maturity')" :value="1"></v-radio>
                                        <v-radio :label="$t('Invoice-Date')" :value="2"></v-radio>
                                    </v-radio-group>
                                </v-flex>

                                <v-flex xs12 sm6 md3>
                                    <v-radio-group v-model="EkstreHesap.ProgramTip" :label="$t('Program-Type')" column>
                                        <v-radio :label="$t('All')" :value="0"> </v-radio>
                                        <v-radio :label="$t('Only')+ 'COPER'" :value="1"></v-radio>
                                        <v-radio :label="'Coper' + $t('Excluding')" :value="2"></v-radio>
                                    </v-radio-group>
                                </v-flex>

                                <v-flex xs12 sm6 md12 v-if="EkstreHesap.RaporTip===true">
                                    <v-alert :value="true" color="info" icon="info" outline>
                                        {{ $t('Report-type-selected-summary-your-extract-will-issued-per-invoice-date') }}
                                    </v-alert>
                                </v-flex>

                                <v-flex xs12 sm6 md6>
                                    <v-layout justify-space-between column>
                                        <v-checkbox :label="$t('Show-Sub-Accounts-Main-Account')" v-model="EkstreHesap.AltHesapGoster" hide-details="">
                                        </v-checkbox> 
                                        <v-checkbox :label="$t('Show-Zero-Amounts')" v-model="EkstreHesap.SifirTutar" hide-details="">
                                        </v-checkbox>
                                        <v-checkbox :label="$t('Do-Not-Show-Records-without-Coper-Invoice')" v-model="EkstreHesap.CoperKayit" hide-details=""></v-checkbox>
                                        <v-checkbox :label="$t('Show-Passenger-Details-in-Ticket-Sales')" v-model="EkstreHesap.BsYolcuDetay" hide-details=""></v-checkbox>
                                        <v-checkbox :label="$t('All-Companies')" v-model="tumsirketler" hide-details=""></v-checkbox>
                                        <v-checkbox :label="$t('Komisyon Açıklaması Yazılsın')" v-model="EkstreHesap.KomFaturaAciklamaAktif" hide-details></v-checkbox>
                                    </v-layout>
                                </v-flex>

                            </v-layout>
                        </v-card-text>

                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                            <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-container fluid="">
                    <v-card color="grey lighten-5" flat>
                        <v-form ref="formcariyegore" v-model="valid" lazy-validation>

                            <v-layout row wrap="">

                                <v-flex xs12 sm6 md2>
                                    <tarihcomp :etiket="$t('Starting-Date')" v-bind:defaultvalue="'no'" v-bind:value="EkstreHesap.BaslangicTarih" :rules="[v => !!v || $t('Please-select-a-date')]" v-model="EkstreHesap.BaslangicTarih"></tarihcomp>
                                </v-flex>

                                <v-flex xs12 sm6 md2>
                                    <tarihcomp :etiket="$t('Finishing-Date')" :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="EkstreHesap.BitisTarih" v-model="EkstreHesap.BitisTarih">
                                    </tarihcomp>
                                </v-flex>

                                <v-flex xs12 sm12 md3>
                                    <cariaracomp v-bind:etiket="$t('Current-Account')" :loading="loading" :rules="true" v-bind:value="EkstreHesap.Cari.Kod" v-model="EkstreHesap.Cari.Kod"></cariaracomp>
                                </v-flex>

                                <v-flex>
                                    <v-layout>
                                        <div v-if="load1">
                                            <v-btn color="info" @click="getList()" fab small="" dark>
                                                <v-icon>search</v-icon>
                                            </v-btn>
                                        </div>

                                        <v-badge color="white" :overlap="true">
                                            <template v-slot:badge>
                                                <v-icon v-if="filtrevarmi" large color="green">
                                                    check_circle_outline </v-icon>
                                            </template>

                                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()" color="info" fab dark>
                                                <v-icon>filter_list</v-icon>
                                            </v-btn>
                                            <v-tooltip bottom="" :activator="el" v-model="tooltip">
                                                <span>{{$t('Add-Search-Filter')}}</span>
                                            </v-tooltip>

                                        </v-badge>

                                    </v-layout>
                                </v-flex>
                                <v-flex v-show="EkstreHesap.RaporDvzTip == 1 || EkstreHesap.RaporDvzTip == 2" xs12 sm12 md12>
                                    <v-layout justify-end="" fill-height="">
                                        <v-btn @click="detayaGit()" flat color="info"> {{ $t('Click-grand-totals') }} </v-btn>
                                    </v-layout>

                                </v-flex>
                            </v-layout>
                        </v-form>
                        <v-layout>
                            <v-flex xs12 sm12 md12>
                                <v-card flat>
                                    <v-data-table dense :headers="headers" class="elevation-1" :rows-per-page-items=[50,100] :loading="progress" :items="items" :search="search3">
                                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                            <td class="text-xs-left">{{ props.item.Evrak.Evrakkod }}</td>
                                            
                                            <td class="text-xs-left"  v-if="props.item.Faturano!=null && props.item.Faturano!='' && props.item.Faturano!='0'">{{ props.item.Faturano}}</td>
                                            <td class="text-xs-left" v-else>
                                                {{ props.item.Evrakno}}
                                        </td>
                                            <td class="text-xs-left">{{ props.item.Aciklama}}</td>
                                            <td class="text-xs-left">{{ props.item.Vade | dateformat}}</td>

                                            <td v-if="EkstreHesap.RaporDvzTip==2" class="text-xs-right">{{ props.item.Tutar | moneyformat}}
                                            </td>

                                            <td v-if="EkstreHesap.RaporDvzTip==2" class="text-xs-center">{{ props.item.BA}}
                                            </td>

                                            <td v-if="EkstreHesap.RaporDvzTip==1 || EkstreHesap.RaporDvzTip==2" class="text-xs-center">
                                                {{ props.item.Doviz.DovizKod }}
                                            </td>

                                            <td v-if="EkstreHesap.RaporDvzTip==0" class="text-xs-right">{{ props.item.Borc | moneyformat}}</td>

                                            <td v-if="EkstreHesap.RaporDvzTip==1 || EkstreHesap.RaporDvzTip==2" class="text-xs-right">
                                                {{ props.item.DvzBorc | moneyformat}}</td>

                                            <td v-if="EkstreHesap.RaporDvzTip==0" class="text-xs-right">{{ props.item.Alacak | moneyformat}}
                                            </td>

                                            <td v-if="EkstreHesap.RaporDvzTip==1 || EkstreHesap.RaporDvzTip==2" class="text-xs-right">
                                                {{ props.item.DvzAlacak | moneyformat}}</td>

                                            <td v-if="EkstreHesap.RaporDvzTip==0" class="text-xs-right">
                                                {{ props.item.Bakiye | bakiyekontrol }}</td>

                                        </template>
                                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                             {{ $t('No-records-searched-for', { value: search3}) }}
                                        </v-alert>
                                    </v-data-table>
                                </v-card>
                                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                                    {{ text1 }}
                                    <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
                                </v-snackbar>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-container>

                <div class="icerik" id="icerik">&nbsp;</div>

                <v-container v-show="EkstreHesap.RaporDvzTip == 1 || EkstreHesap.RaporDvzTip == 2" fluid="">
                    <v-flex sm12 md12>
                        <v-flex xs12 sm12 md12>
                            <v-card flat="" class="black--text">
                                <v-card flat="">
                                    <v-card-actions>
                                        <v-layout row wrap>
                                            <v-flex pb-2 xs12 sm12 md12>
                                                <v-layout align-center="" justify-start="" fill-height="">
                                                    <span class="subheading info--text font-weight-"> {{ $t('Turnover-General-Totals') }}
                                                    </span>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm12 md12>
                                                <v-card flat class="black--text">
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-start="" fill-height="">
                                                                <span class="body-2 font-weight-"> {{ $t('Currency-Type') }}
                                                                </span>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2 font-weight-">
                                                                    {{ $t('Transfer-Payable') }}
                                                                </span>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2 font-weight-">
                                                                    {{ $t('Transfer-Receivable') }}
                                                                </span>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2 font-weight-">
                                                                    {{$t('Transfer-Balance')}}
                                                                </span>
                                                            </v-layout>
                                                        </v-flex>

                                                    </v-layout>
                                                    <v-divider light></v-divider>

                                                    <v-layout row wrap v-for="item in dovizToplamlar" :key="item.id">
                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-start="" fill-height="">
                                                                <span class="body-2 font-weight-thin">
                                                                    {{item.Doviz.DovizKod}} </span>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2 font-weight-thin">
                                                                    {{item.DevirBorc | moneyformat}}</span>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2n font-weight-thin">
                                                                    {{item.DevirAlacak | moneyformat}}</span>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2 font-weight-thin">
                                                                    {{item.DevirBakiye | bakiyekontrol}}</span>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm3 md12>
                                                            <v-divider light></v-divider>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card>
                                            </v-flex>

                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-card>
                        </v-flex>
                    </v-flex>
                </v-container>

                <v-container v-show="EkstreHesap.RaporDvzTip == 1 || EkstreHesap.RaporDvzTip == 2" fluid="">
                    <v-flex sm12 md12>
                        <v-flex xs12 sm12 md12>
                            <v-card flat="" class="black--text">
                                <v-card flat="">
                                    <v-card-actions>
                                        <v-layout row wrap>
                                            <v-flex pb-2 xs12 sm12 md12>
                                                <v-layout align-center="" justify-start="" fill-height="">
                                                    <span class="subheading info--text font-weight-"> {{ $t('Term-General-Totals') }}
                                                    </span>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 sm12 md12>
                                                <v-card flat class="black--text">

                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-start="" fill-height="">
                                                                <span class="body-2 font-weight-"> {{ $t('Currency-Type') }}
                                                                </span>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2 font-weight-">
                                                                    {{ $t('Payable-for-Period') }}
                                                                </span>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2 font-weight-">
                                                                    {{ $t('Receivable-for-Period') }}
                                                                </span>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2 font-weight-">
                                                                    {{ $t('Balance-for-Period') }}
                                                                </span>
                                                            </v-layout>
                                                        </v-flex>

                                                    </v-layout>
                                                    <v-divider light></v-divider>
                                                    <v-layout row wrap v-for="item in dovizToplamlar" :key="item.id">
                                                        <v-flex xs12 sm2 md3>
                                                            <v-layout align-center="" justify-start="" fill-height="">
                                                                <span class="body-2 font-weight-thin">
                                                                    {{item.Doviz.DovizKod}} </span>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2 font-weight-thin">
                                                                    {{item.DonemBorc | moneyformat}}</span>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2 font-weight-thin">
                                                                    {{item.DonemAlacak | moneyformat}}
                                                                </span>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2 font-weight-thin">
                                                                    {{item.DonemBakiye | bakiyekontrol}}
                                                                </span>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-divider light></v-divider>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-card>
                        </v-flex>
                    </v-flex>
                </v-container>

                <v-container v-show="EkstreHesap.RaporDvzTip == 1 || EkstreHesap.RaporDvzTip == 2" fluid="">
                    <v-flex sm12 md12>
                        <v-flex xs12 sm12 md12>
                            <v-card flat="" class="black--text">
                                <v-card flat="">
                                    <v-card-actions>
                                        <v-layout row wrap>
                                            <v-flex pb-2 xs12 sm12 md12>
                                                <v-layout align-center="" justify-start="" fill-height="">
                                                    <span class="subheading info--text font-weight-"> {{ $t('General-Totals') }}
                                                    </span>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 sm12 md12>
                                                <v-card flat class="black--text">

                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-start="" fill-height="">
                                                                <span class="body-2 font-weight-">  {{ $t('Currency-Type') }}
                                                                </span>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2 font-weight-">
                                                                    {{ $t('General-Debit') }}
                                                                </span>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2 font-weight-">
                                                                    {{ $t('General-Credit') }}
                                                                </span>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2 font-weight-">
                                                                    {{ $t('General-Balance') }}
                                                                </span>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-divider light></v-divider>

                                                    <v-layout row wrap v-for="item in dovizToplamlar" :key="item.id">
                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-start="" fill-height="">
                                                                <span class="body-2 font-weight-thin">
                                                                    {{item.Doviz.DovizKod}} </span>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2 font-weight-thin">
                                                                    {{item.ToplamBorc | moneyformat}}
                                                                </span>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2 font-weight-thin">
                                                                    {{item.ToplamAlacak | moneyformat}}
                                                                </span>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm3 md3>
                                                            <v-layout align-center="" justify-end="" fill-height="">
                                                                <span class="body-2 font-weight-thin">
                                                                    {{item.ToplamBakiye | bakiyekontrol}}
                                                                </span>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-divider light></v-divider>
                                                        </v-flex>
                                                    </v-layout>

                                                </v-card>
                                            </v-flex>

                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-card>
                        </v-flex>

                    </v-flex>
                </v-container>

            </v-layout>
        </v-card>
    </v-app>
</div>
</template>

<script>
import auth from '../../../api/auth'
import tarihcomp from '../customcomp/tarihim'
import helpers from "@/components/app/customcomp/helpers.js"
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
export default {
    data() {
        return {
    mailDialog:false,
    mailValid:false,
    mailLoading:false,
    mailPayload:{
        To:"",
        AgencyName:"",
        DocType:"Hesap Ekstresi - Statement of Account",
        AgentFullName:"",
        CustomBody:"",
        },
        rules:{
            required: v => !!v || 'Zorunlu alan',
            email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'
        },
            PB:"TRY",
            sayfayetki: {
                Screen: false,
                Update: false,
                Save: false,
                Delete: false,
                Status: false,
                Message: null,
                islem: 0,
            },
            ReferansPrm: {
                Kod: null},
                NoReferansPrm: {
                Kod: null,},
            filtrevarmi: false,
            search: '',
            dovizToplamlar: [],
            headerstl: [{
                    text: this.$t('Date'),
                    value: 'Tarih'
                },
                {
                    text: this.$t('Document-Type'),
                    value: 'Evrak.Evrakkod'
                },
                {
                    text: this.$t('Document-No'),
                    value: 'Evrakno'
                },
                {
                    text: this.$t('Description'),
                    value: 'Aciklama'
                },
                {
                    text: this.$t('Maturity-Date'),
                    value: 'Vade'
                },
                {
                    text: this.$t('Debit'),
                    value: 'Borc',
                    align: 'right'

                }, {
                    text: this.$t('Credit'),
                    value: 'Alacak',
                    align: 'right'
                },

                {
                    text: this.$t('Balance'),
                    value: 'Bakiye',
                    align: 'right'

                }
            ],
            headersdoviz: [{
                    text: this.$t('Date'),
                    value: 'Tarih'
                },
                {
                    text: this.$t('Document-Type'),
                    value: 'Evrak.Evrakkod'
                },
                {
                    text: this.$t('Document-No'),
                    value: 'Evrakno'
                },
                {
                    text: this.$t('Description'),
                    value: 'Aciklama'
                },
                {
                    text: this.$t('Maturity-Date'),
                    value: 'Vade'
                },
                {
                    text: this.$t('Currency'),
                    value: 'Doviz.DovizKod',
                },
                {
                    text: this.$t('Debit'),
                    value: 'Borc',
                    align: 'right'

                }, {
                    text: this.$t('Credit'),
                    value: 'Alacak',
                    align: 'right'
                }
            ],
            headerstldoviz: [{
                    text: this.$t('Date'),
                    value: 'Tarih'
                },
                {
                    text: this.$t('Document-Type'),
                    value: 'Evrak.Evrakkod'
                },
                {
                    text: this.$t('Document-No'),
                    value: 'Evrakno'
                },
                {
                    text: this.$t('Description'),
                    value: 'Aciklama'
                },
                {
                    text: this.$t('Maturity-Date'),
                    value: 'Vade'
                }, {
                    text: this.$t('Amount'),
                    value: 'Tutar',
                    align: 'right'
                },
                {
                    text: 'BA',
                    value: 'BA',
                },
                {
                    text: this.$t('Currency'),
                    value: 'Doviz.DovizKod',
                },
                {
                    text: this.$t('Debit'),
                    value: 'Borc',
                    align: 'right'

                }, {
                    text: this.$t('Credit'),
                    value: 'Alacak',
                    align: 'right'
                }
            ],
            EkstreHesap: {

                SirketKodu: null,
                Cari: {
                    Kod: null
                },
                BaslangicTarih: null,
                BitisTarih: null,
                IstenilenReferanslar: [],
                IstenmeyenReferanslar: [],
                Masraflar: [],
                Gruplar: [],
                NoGruplar: [],
                Evraklar: [],
                Tarihler: 0, // 0 : Tarih,  1 : Vade , 2 : Fatura Tarihi
                RaporTip: false, // false : Detay, true : Ozet
                RaporDvzTip: 0, // 0 : tl, 1 : dvz, 2 : tl+dvz
                BsYolcuDetay: false,
                SifirTutar: false,
                AltHesapGoster:false,
                DevirGoster: false,
                AltHesapGosterme: false,
                TlAta: false,
                CoperKayit: false,
                KomFaturaAciklamaAktif: false,
                ProgramTip: 0 //0 : Hepsi,1 : Sadece Coper, 2 : Coper Hariç
            },
            devirborc: 0,
            deviralacak: 0,
            devirbakiye: 0,
            donemborc: 0,
            donemalacak: 0,
            donembakiye: 0,
            toplamborc: 0,
            toplamalacak: 0,
            toplambakiye: 0,
            valid: true,
            statecari: [],
            searchcari: '',
            Carihesap: '',
            text1: null,
            loading: false,
            progress: false,
            renk1: 'info',
            items: [],
            load: false,
            load1: true,
            search3: '',
            dialogfiltre: false,
            hesapkodu: [],
            Referans: [],
            masrafmerkezi: [],
            isDisabled:false,
            tumsirketler: false,
            anahesap: [],
            hesapgurubu: [],
            evraktipi: [],
            mizan: '',
            butondurum: true,
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            tooltip: false,
            el: null,
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from.path
        })
    },
    beforeMount: beforeMount,
    components: {
        tarihcomp,
        yetkidialog,
        cariaracomp,
        referansmerkezicomp
    },
    mounted() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi
        var d = new Date();
           
        this.EkstreHesap.BaslangicTarih = d.getFullYear()  + "-01-01T00:00:00" ; 

        this.el = this.$refs.fab.$el
        this.devirbakiye = '0.00' + this.getparabirimi();
        this.donembakiye = '0.00' + this.getparabirimi();
        this.toplambakiye = '0.00' + this.getparabirimi();

        this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

        if (this.sayfayetki.Status == true) {

        } else {

            this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

                if (sonuc == true) {

                    if (this.prevRoute != null) {
                        let url = '#' + this.prevRoute

                        window.open(url, '_self')
                    } else {
                        let url = '#/'
                        window.open(url, '_self')
                    }
                } 

            });

        }

    },
    watch: {

        'EkstreHesap.RaporDvzTip': function (a) {
            if (a == 1 || a == 2) {
                this.EkstreHesap.RaporTip = false
            }

            if (a == 0) {
                this.headers = this.headerstl
            } else if (a == 1) {
                this.headers = this.headersdoviz
            } else if (a == 2) {
                this.headers = this.headerstldoviz
            }
        },
        'EkstreHesap.RaporTip': function (a) {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            if (a == false) {
                    this.isDisabled = false;
                    //this.EkstreHesap.RaporDvzTip = 0;
            } else if (a == true) {
                this.EkstreHesap.Tarihler = 0;
                    this.isDisabled = false;
        
                    // if (this.EkstreHesap.RaporDvzTip == 1 || this.EkstreHesap.RaporDvzTip == 2) {
                    //     this.EkstreHesap.RaporDvzTip = 0;
                    // }else{
                    //     this.isDisabled = true;
                    // }
           
            }
        }
    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
        moneyformat: function (m) {
            return helpers.moneyformat(m);
        },

        bakiyekontrol: function (m) {
            return helpers.bakiyekontrol(m);
        }
    },
    methods: {
openMailDialog() {
  try {
    const credentials = JSON.parse(window.localStorage.getItem('credentials')) || {};
    if (!this.mailPayload.AgentFullName && credentials.UserName) {
      this.mailPayload.AgentFullName = credentials.UserName;
    }
  } catch (e) {}
  this.mailDialog = true;
},

closeMailDialog() {
  this.mailDialog = false;
},

async sendMail() {
  if (!this.$refs.mailForm.validate()) return;

  const url = auth.API_URL + 'api/Abstract/MailGonderEkstre';

  const credentials = JSON.parse(window.localStorage.getItem('credentials')) || {};
  const begin = this.EkstreHesap.BaslangicTarih
    ? String(this.EkstreHesap.BaslangicTarih).slice(0, 10)
    : this.EkstreHesap.BaslangicTarih;
  const end = this.EkstreHesap.BitisTarih
    ? String(this.EkstreHesap.BitisTarih).slice(0, 10)
    : this.EkstreHesap.BitisTarih;

  const istRef = [];
  if (this.ReferansPrm && this.ReferansPrm.Kod) istRef.push(this.ReferansPrm);
  (this.EkstreHesap.IstenilenReferanslar || []).forEach(k => istRef.push({ Kod: k }));

  const noRef = [];
  if (this.NoReferansPrm && this.NoReferansPrm.Kod) noRef.push(this.NoReferansPrm);

  const input = {
    AktifSirketKodu: credentials.SirketKodu,
    SirketKodu: this.tumsirketler ? 0 : credentials.SirketKodu,
    Cari: { Kod: this.EkstreHesap.Cari.Kod },
    BaslangicTarih: begin,
    BitisTarih: end,
    AltHesapGoster: this.EkstreHesap.AltHesapGoster,
    AltHesapGosterme: this.EkstreHesap.AltHesapGosterme,
    BsYolcuDetay: this.EkstreHesap.BsYolcuDetay,
    CoperKayit: this.EkstreHesap.CoperKayit,
    DevirGoster: this.EkstreHesap.DevirGoster,
    Evraklar: (this.EkstreHesap.Evraklar || []).map(x => ({ Evrakkod: x })),
    Gruplar: this.EkstreHesap.Gruplar || [],
    NoGruplar: this.EkstreHesap.NoGruplar || [],
    IstenilenReferanslar: istRef,
    IstenmeyenReferanslar: noRef,
    Masraflar: (this.EkstreHesap.Masraflar || []).map(code => ({ Code: code })),
    KomFaturaAciklamaAktif: this.EkstreHesap.KomFaturaAciklamaAktif,
    ProgramTip: this.EkstreHesap.ProgramTip,
    RaporDvzTip: this.EkstreHesap.RaporDvzTip,
    RaporTip: this.EkstreHesap.RaporTip,
    SifirTutar: this.EkstreHesap.SifirTutar,
    TlAta: this.EkstreHesap.TlAta,
    Tarihler: this.EkstreHesap.Tarihler
  };

  const mail = {
    To: (this.mailPayload.To || '').trim(),
    AgencyName: (this.mailPayload.AgencyName || '').trim(),
    DocType: (this.mailPayload.DocType || '').trim(),
    AgentFullName: (this.mailPayload.AgentFullName || '').trim(),
    CustomBody: (this.mailPayload.CustomBody || '').trim()
  };

  const request = { Input: input, Mail: mail };

  this.mailLoading = true;
  try {
    await this.$http.post(url, request, {
      headers: {
        Authorization: 'Bearer ' + auth.getAuthHeader(),
        'Content-Type': 'application/json'
      }
    });
    this.text1 = 'Mail gönderildi.';
    this.snackbar = true;
    this.closeMailDialog();
  } catch (err) {
    const body = err && err.body ? err.body : {};
    const msg = body.Message || body.message || 'Mail gönderilemedi.';
    this.text1 = msg;
    this.snackbar = true;
  } finally {
    this.mailLoading = false;
  }
},

        getparabirimi() {
            return helpers.getparabirimi()
        },
        detayaGit() {

            var target = document.getElementById('icerik')

            var scrollContainer = document.getElementById('icerik')
            do { //find scroll container
                scrollContainer = scrollContainer.parentNode;
                if (!scrollContainer) return;
                scrollContainer.scrollTop += 1;
            } while (scrollContainer.scrollTop == 0);

            var targetY = 0;
            do { //find the top of target relatively to the container
                if (target == scrollContainer) break;
                targetY += target.offsetTop;
            } while (target = target.offsetParent);

            scroll = function (c, a, b, i) {
                i++;
                if (i > 30) return;
                c.scrollTop = a + (b - a) / 30 * i;
                setTimeout(function () {
                    scroll(c, a, b, i);
                }, 20);
            }
            // start scrolling
            scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);

        },
        getList: getList,
        getListHtml: getListHtml,
        getListExcel: getListExcel,
        filtrele: filtrele,
        filtrekayit: filtrekayit,
        filtreiptal: filtreiptal,
    }
}

function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
        CompanyCode: credentials.SirketKodu
    }

    // this.$http.post(auth.API_URL + 'api/Reference/List', params3, {
    //     headers: {
    //         'Authorization': 'Bearer ' + auth.getAuthHeader()
    //     }
    // }).then((response) => {
    //     this.Referans = response.body
    // }, (response) => {
    //     if (response.status === 0) {
    //         this.text1 = 'Service Unavailable'
    //         this.snackbar = true
    //     } else {
    //         this.text1 = 'Service Unavailable'
    //         this.snackbar = true
    //     }
    // })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params3, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.masrafmerkezi = response.body
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.hesapgurubu = response.body
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        }
    })

    this.$http.post(auth.API_URL + 'api/doctype/List', params3, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.evraktipi = response.body

    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        }
    })

}

function filtrekayit() {
    this.filtrevarmi = true
    this.getList();
    this.dialogfiltre = false
}

function filtreiptal() {
    this.filtrevarmi = false
    this.dialogfiltre = false
    this.tumsirketler = false
    this.EkstreHesap.IstenilenReferanslar = []
    this.EkstreHesap.IstenmeyenReferanslar = []
    this.EkstreHesap.Masraflar = []
    this.EkstreHesap.Gruplar = []
    this.EkstreHesap.NoGruplar = []
    this.EkstreHesap.Evraklar = []
    this.EkstreHesap.Tarihler = 0 // 0 : Tarih,  1 : Vade , 2 : Fatura Tarihi
    this.EkstreHesap.RaporTip = false // false : Detay, true : Ozet
    this.EkstreHesap.RaporDvzTip = 0 // 0 : tl, 1 : dvz, 2 : tl+dvz
    this.EkstreHesap.BsYolcuDetay = false
    this.EkstreHesap.SifirTutar = false
    this.EkstreHesap.DevirGoster = false
    this.EkstreHesap.AltHesapGosterme = false
    this.EkstreHesap.TlAta = false
    this.EkstreHesap.CoperKayit = false
    this.EkstreHesap.ProgramTip = 0 //0 : Hepsi,1 : Sadece Coper, 2 : Coper Hariç
    this.EkstreHesap.AltHesapGoster = false
}

function getList() {

    var bastarih = new Date(this.EkstreHesap.BaslangicTarih)
    var bittarih = new Date(this.EkstreHesap.BitisTarih)

    if (bastarih <= bittarih) {

        if (this.$refs.formcariyegore.validate()) {
            var params = {
                AktifSirketKodu:null,
                SirketKodu: null,
                Cari: {
                    Kod: this.EkstreHesap.Cari.Kod
                },
                BaslangicTarih: this.EkstreHesap.BaslangicTarih,
                BitisTarih: this.EkstreHesap.BitisTarih,
                IstenilenReferanslar: [],
                IstenmeyenReferanslar: [],
                Masraflar: [],
                Gruplar: this.EkstreHesap.Gruplar,
                NoGruplar: this.EkstreHesap.NoGruplar,
                Evraklar: [],
                Tarihler: this.EkstreHesap.Tarihler,
                RaporTip: this.EkstreHesap.RaporTip,
                RaporDvzTip: this.EkstreHesap.RaporDvzTip,
                BsYolcuDetay: this.EkstreHesap.BsYolcuDetay,
                SifirTutar: this.EkstreHesap.SifirTutar,
                DevirGoster: this.EkstreHesap.DevirGoster,
                AltHesapGosterme: this.EkstreHesap.AltHesapGosterme,
                TlAta: this.EkstreHesap.TlAta,
                CoperKayit: this.EkstreHesap.CoperKayit,
                ProgramTip: this.EkstreHesap.ProgramTip,
                AltHesapGoster: this.EkstreHesap.AltHesapGoster,
                KomFaturaAciklamaAktif: this.EkstreHesap.KomFaturaAciklamaAktif
            }

            this.progress = true
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            var lang = localStorage.getItem('lang');
            if (this.tumsirketler == true) {
                params.SirketKodu = 0
                params.AktifSirketKodu=credentials.SirketKodu
            } else {
                params.SirketKodu = credentials.SirketKodu
                params.AktifSirketKodu = credentials.SirketKodu
            }

            
    if (this.ReferansPrm.Kod!='' && this.ReferansPrm.Kod!=null)
    {
        params.IstenilenReferanslar.push(this.ReferansPrm);
    }
    
    if (this.NoReferansPrm.Kod!='' && this.NoReferansPrm.Kod!=null)
    {
        params.IstenmeyenReferanslar.push(this.NoReferansPrm);
    }

            this.EkstreHesap.IstenilenReferanslar.forEach(element => {
                var kayit = {
                    Kod: element
                }
                params.IstenilenReferanslar.push(kayit)
            });

            // this.EkstreHesap.IstenmeyenReferanslar.forEach(element => {
            //     var kayit = {
            //         Kod: element
            //     }
            //     params.IstenmeyenReferanslar.push(kayit)
            // });

            this.EkstreHesap.Masraflar.forEach(element => {
                var kayit = {
                    Code: element
                }
                params.Masraflar.push(kayit)
            });

            this.EkstreHesap.Evraklar.forEach(element => {
                var kayit = {
                    Evrakkod: element
                }
                params.Evraklar.push(kayit)
            });

            this.load1 = false

            this.$http.post(auth.API_URL + 'api/Abstract/ListWithCurrentDetail', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {

                this.progress = false
                this.load1 = true

                if (response.body[0] != undefined) {


                    response.body[0].EkstreList.forEach((item, index)=>{
	if (item.BA=="B")
    {
        item.BA="D";
    }
    else
    {
        item.BA="C";
    }
})
                    var donus=response.body[0].EkstreList
                    donus.forEach((item, index)=>{
	if (item.BA=="B")
    {
        item.BA="D";
    }
    else
    {
        item.BA="C";
    }
})

                    this.items = donus 
                    console.log(this.items)
                   
                    var simge = this.getparabirimi()

                    if (this.EkstreHesap.RaporDvzTip == 0) {

                        this.devirborc = response.body[0].Toplamlar[0].DevirBorc
                        this.deviralacak = response.body[0].Toplamlar[0].DevirAlacak

                        if (response.body[0].Toplamlar[0].DevirBakiye < 0) {
                            this.devirbakiye = response.body[0].Toplamlar[0].DevirBakiye * -1;
                            this.devirbakiye = this.devirbakiye.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
                                '$1,') + simge + ' A ';

                        } else {
                            this.devirbakiye = response.body[0].Toplamlar[0].DevirBakiye.toFixed(2).replace(
                                /(\d)(?=(\d{3})+\.)/g,
                                '$1,') + simge + ' B '
                        }

                        this.donemborc = response.body[0].Toplamlar[0].DonemBorc
                        this.donemalacak = response.body[0].Toplamlar[0].DonemAlacak

                        if (response.body[0].Toplamlar[0].DonemBakiye < 0) {
                            this.donembakiye = response.body[0].Toplamlar[0].DonemBakiye * -1;
                            this.donembakiye = this.donembakiye.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
                                '$1,') + simge + ' A  ';

                        } else {
                            this.donembakiye = response.body[0].Toplamlar[0].DonemBakiye.toFixed(2).replace(
                                /(\d)(?=(\d{3})+\.)/g,
                                '$1,') + simge + ' B '
                        }

                        this.toplamborc = response.body[0].Toplamlar[0].ToplamBorc
                        this.toplamalacak = response.body[0].Toplamlar[0].ToplamAlacak

                        if (response.body[0].Toplamlar[0].ToplamBakiye < 0) {
                            this.toplambakiye = response.body[0].Toplamlar[0].ToplamBakiye * -1;
                            this.toplambakiye = this.toplambakiye.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
                                '$1,') + simge + ' A  ';

                        } else {
                            this.toplambakiye = response.body[0].Toplamlar[0].ToplamBakiye.toFixed(2).replace(
                                /(\d)(?=(\d{3})+\.)/g,
                                '$1,') + simge + ' B'
                        }
                    }

                    if (this.EkstreHesap.RaporDvzTip == 1 || this.EkstreHesap.RaporDvzTip == 2) {
                        this.dovizToplamlar = response.body[0].Toplamlar
                    }
                    
                   
                } else {
                    this.text1 = this.$t('No-Records-Found');
                    this.snackbar = true;
                    this.progress = false;
                    this.load1 = true;
                    this.items = [];
                }

            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true

                    this.load1 = true
                    this.progress = false

                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                    this.load1 = true
                    this.progress = false
                }
            })

        }

    } else {

        this.load1 = true

        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true

    }

}

function getListHtml() {

    if (this.$refs.formcariyegore.validate()) {

        var params = {
            AktifSirketKodu:null,
            SirketKodu: null,
            Cari: {
                Kod: this.EkstreHesap.Cari.Kod
            },
            BaslangicTarih: this.EkstreHesap.BaslangicTarih,
            BitisTarih: this.EkstreHesap.BitisTarih,
            IstenilenReferanslar: [],
            IstenmeyenReferanslar: [],
            Masraflar: [],
            Gruplar: this.EkstreHesap.Gruplar,
            NoGruplar: this.EkstreHesap.NoGruplar,
            Evraklar: [],
            Tarihler: this.EkstreHesap.Tarihler,
            RaporTip: this.EkstreHesap.RaporTip,
            RaporDvzTip: this.EkstreHesap.RaporDvzTip,
            BsYolcuDetay: this.EkstreHesap.BsYolcuDetay,
            SifirTutar: this.EkstreHesap.SifirTutar,
            DevirGoster: this.EkstreHesap.DevirGoster,
            AltHesapGosterme: this.EkstreHesap.AltHesapGosterme,
            TlAta: this.EkstreHesap.TlAta,
            CoperKayit: this.EkstreHesap.CoperKayit,
            ProgramTip: this.EkstreHesap.ProgramTip,
            AltHesapGoster: this.EkstreHesap.AltHesapGoster,
            KomFaturaAciklamaAktif: this.EkstreHesap.KomFaturaAciklamaAktif
        }

        this.progress = true
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var lang = localStorage.getItem('lang')

        if (this.tumsirketler == true) {
            params.SirketKodu = 0
            params.AktifSirketKodu=credentials.SirketKodu
        } else {
            params.SirketKodu = credentials.SirketKodu
            params.AktifSirketKodu=credentials.SirketKodu
        }

        if (this.ReferansPrm.Kod!='' && this.ReferansPrm.Kod!=null)
    {
        params.IstenilenReferanslar.push(this.ReferansPrm);
    }
    
    if (this.NoReferansPrm.Kod!='' && this.NoReferansPrm.Kod!=null)
    {
        params.IstenmeyenReferanslar.push(this.NoReferansPrm);
    }

        this.EkstreHesap.Masraflar.forEach(element => {
            var kayit = {
                Code: element
            }
            params.Masraflar.push(kayit)
        });

        this.EkstreHesap.Evraklar.forEach(element => {
            var kayit = {
                Evrakkod: element
            }
            params.Evraklar.push(kayit)
        });

        this.load1 = false

        this.$http.post(auth.API_URL + 'api/Abstract/ListWithCurrentDetailHtml', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {


          if (lang=='en')
          {
            response.bodyText=response.bodyText.toString().replaceAll(" B"," D");
            response.bodyText=response.bodyText.toString().replaceAll(" A"," C");
             var bodyhtml=helpers.getTranslatedHtml(response.bodyText) ;

             bodyhtml=bodyhtml.toString().replace('<title> CARİ HESAP EKSTRESİ </title>','<title> CURRENT ACCOUNT STATEMENT </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>CARİ HESAP EKSTRESİ</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>CURRENT ACCOUNT STATEMENT</font>")
             bodyhtml=bodyhtml.toString().replace(" Referance(İstenmeyen) :","Referance(Unwanted) :")
             bodyhtml=bodyhtml.toString().replace("Referance (İstelenilen) :","Referance (Desired) :")
             bodyhtml=bodyhtml.toString().replace("TL Rapor","RS Report")
             bodyhtml=bodyhtml.toString().replace("Hepsi","All")
             bodyhtml=bodyhtml.toString().replace(" B"," D")
             response.bodyText=bodyhtml;
             
          }

            this.load = false
            this.load1 = true
            this.progress = false
            var blob = new Blob([response.bodyText], {
                type: 'application/html'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = this.$t('AccountStatement') + ".html";
            link.click();

        }, (response) => {
            if (response.status === 0) {
                this.text = 'Service Unavailable'
                this.snackbar = true
                this.load1 = true
                this.progress = false

            } else {
                this.text = 'Service Unavailable'
                this.snackbar = true
                this.load1 = true
                this.progress = false

            }
        })

    }

}

function getListExcel() {
    if (this.$refs.formcariyegore.validate()) {

        var params = {
            AktifSirketKodu:null,
            SirketKodu: null,
            Cari: {
                Kod: this.EkstreHesap.Cari.Kod
            },
            BaslangicTarih: this.EkstreHesap.BaslangicTarih,
            BitisTarih: this.EkstreHesap.BitisTarih,
            IstenilenReferanslar: [],
            IstenmeyenReferanslar: [],
            Masraflar: [],
            Gruplar: this.EkstreHesap.Gruplar,
            NoGruplar: this.EkstreHesap.NoGruplar,
            Evraklar: [],
            Tarihler: this.EkstreHesap.Tarihler,
            RaporTip: this.EkstreHesap.RaporTip,
            RaporDvzTip: this.EkstreHesap.RaporDvzTip,
            BsYolcuDetay: this.EkstreHesap.BsYolcuDetay,
            SifirTutar: this.EkstreHesap.SifirTutar,
            DevirGoster: this.EkstreHesap.DevirGoster,
            AltHesapGosterme: this.EkstreHesap.AltHesapGosterme,
            TlAta: this.EkstreHesap.TlAta,
            CoperKayit: this.EkstreHesap.CoperKayit,
            ProgramTip: this.EkstreHesap.ProgramTip,
            AltHesapGoster:this.EkstreHesap.AltHesapGoster,
            KomFaturaAciklamaAktif: this.EkstreHesap.KomFaturaAciklamaAktif
        }

        this.progress = true
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler == true) {
            params.SirketKodu = 0
            params.AktifSirketKodu=credentials.SirketKodu
        } else {
            params.SirketKodu = credentials.SirketKodu
            params.AktifSirketKodu=credentials.SirketKodu
        }

    if (this.ReferansPrm.Kod!='' && this.ReferansPrm.Kod!=null)
    {
        params.IstenilenReferanslar.push(this.ReferansPrm);
    }
    
    if (this.NoReferansPrm.Kod!='' && this.NoReferansPrm.Kod!=null)
    {
        params.IstenmeyenReferanslar.push(this.NoReferansPrm);
    }

        this.EkstreHesap.Masraflar.forEach(element => {
            var kayit = {
                Code: element
            }
            params.Masraflar.push(kayit)
        });

        this.EkstreHesap.Evraklar.forEach(element => {
            var kayit = {
                Evrakkod: element
            }
            params.Evraklar.push(kayit)
        });

        this.load1 = false

        
        this.$http.post(auth.API_URL + 'api/Abstract/ListWithCurrentDetailExcel', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            },
            responseType: "arraybuffer"
        }).then((response) => {
            this.load = false
            this.load1 = true
            this.progress = false
            var blob = new Blob([response.data], {
                type: 'application/xlsx'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = this.$t('AccountStatement') + ".xlsx";
            link.click();

        }, (response) => {
            if (response.status === 0) {
                this.text = 'Service Unavailable'
                this.snackbar = true
                this.load1 = true
                this.progress = false

            } else {
                this.text = 'Service Unavailable'
                this.snackbar = true
                this.load1 = true
                this.progress = false

            }
        })

    }

}

function beforeMount() {
    this.headers = this.headerstl
}
</script>

<style>

</style>
